module.exports = __webpack_public_path__ + "static/assets/9c43d786f5c08113feaeafb87275974a.png";